import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Grid,
  IconButton,
  Stack,
  Alert,
} from '@mui/material';
import {
  Person as PersonIcon,
  EmojiEvents as TrophyIcon,
  Store as StoreIcon,
  SportsEsports as GameIcon,
} from '@mui/icons-material';
import SectionTitle from '../components/SectionTitle';
import PageTitle from '../components/PageTitle';

// Helper component for circular navigation buttons (reused from TournamentDetailsPage)
const NavButton = ({ icon, label, onClick, disabled = false }) => (
  <Box 
    sx={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      gap: 0.5,
      textAlign: 'center'
    }}
  >
    <IconButton
      onClick={onClick}
      disabled={disabled}
      sx={{ 
        width: 56, 
        height: 56, 
        bgcolor: disabled ? 'action.disabledBackground' : '#c89e38', 
        color: disabled ? 'action.disabled' : 'white',
        '&:hover': {
          bgcolor: disabled ? 'action.disabledBackground' : '#b38d2d'
        },
        transition: 'background-color 0.3s ease'
      }}
    >
      {icon}
    </IconButton>
    <Typography variant="caption" sx={{ color: 'text.secondary' }}>
      {label}
    </Typography>
  </Box>
);

const AdminPage = () => {
  const navigate = useNavigate();

  const handleNavigate = (path) => {
    navigate(`/admin/${path}`);
  };

  return (
    <Box sx={{ 
      p: { xs: 1, sm: 1 },
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '90%',
      maxWidth: '1000px',
      mx: 'auto',
      bgcolor: 'transparent'
    }}>
      <Stack spacing={2} sx={{ width: '100%', bgcolor: 'transparent' }}>
        <PageTitle title="Panel de Administración" />

        {/* Navigation Buttons Section */}
        <SectionTitle 
          title="Gestión"
          subtitle="Accede a las secciones de administración"
        >
          <Grid container spacing={2} justifyContent="center">
            <Grid item xs={4} sm={3}>
              <NavButton 
                icon={<PersonIcon />} 
                label="Jugadores" 
                onClick={() => handleNavigate('players')}
              />
            </Grid>
            <Grid item xs={4} sm={3}>
              <NavButton 
                icon={<GameIcon />} 
                label="Resultados" 
                onClick={() => handleNavigate('results')}
              />
            </Grid>
            <Grid item xs={4} sm={3}>
              <NavButton 
                icon={<StoreIcon />} 
                label="Ligas" 
                onClick={() => handleNavigate('leagues')}
              />
            </Grid>
          </Grid>
        </SectionTitle>

        {/* Quick Stats Section */}
        <SectionTitle title="Resumen">
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <Box sx={{ 
                p: 2, 
                border: '1px solid', 
                borderColor: 'divider',
                borderRadius: 2,
                textAlign: 'center'
              }}>
                <Typography variant="h4" color="primary" sx={{ mb: 1 }}>0</Typography>
                <Typography variant="body2" color="text.secondary">Jugadores Registrados</Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={4}>
              <Box sx={{ 
                p: 2, 
                border: '1px solid', 
                borderColor: 'divider',
                borderRadius: 2,
                textAlign: 'center'
              }}>
                <Typography variant="h4" color="primary" sx={{ mb: 1 }}>0</Typography>
                <Typography variant="body2" color="text.secondary">Partidas Registradas</Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={4}>
              <Box sx={{ 
                p: 2, 
                border: '1px solid', 
                borderColor: 'divider',
                borderRadius: 2,
                textAlign: 'center'
              }}>
                <Typography variant="h4" color="primary" sx={{ mb: 1 }}>0</Typography>
                <Typography variant="body2" color="text.secondary">Ligas Activas</Typography>
              </Box>
            </Grid>
          </Grid>
        </SectionTitle>
      </Stack>
    </Box>
  );
};

export default AdminPage; 